// Identifies if given string is a number or not
// Empty string or a string with just spaces is evaluated as not a number.
export const isNumber = (value?: string | null) => {
  return value !== null && value !== undefined && value.trim() !== "" && !isNaN(Number(value));
};
